<template>
  <div id="Client" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 bg-color-white pl5 pr5 fixed-t">
      <div class="col-12 lh40 bg-color-white pl5 pr5">
          <div class="col-3 f18" @click="go_clients()"><i class="iconfont icon-31fanhui1 color-muted"></i></div>
          <div class="col-6 t-c color-white">-</div>
          <div class="col-3 t-r f26" @click="go_install()"><i class="iconfont icon-zhuomianruanjiananzhuangshenqing color-primary"></i></div>
      </div>
      
      <div class="col-12 bg-color-white pl20 pr20 pb20 h24">
        <div class="col-12 t-c">
          <img src="../../assets/store_logo.png" alt="" class="w10 r5">
        </div>
        <div class="col-12 t-c pt10 f14 uppercase">
          RIF: {{ pageData.license_type }}-{{ pageData.license }} <span class="bg-color-warning color-white f12 pt1 pb1 pl3 pr3 r5" v-if="pageData.is_specials == 1">C.E</span>
          <span class="bg-color-muted color-white f12 pt1 pb1 pl3 pr3 r5 ml3" v-if="pageData.status == -1" @click="statusCh()">Bloqueado</span>
          <span class="bg-color-danger color-white f12 pt1 pb1 pl3 pr3 r5 ml3" v-else-if="pageData.status == 0" @click="statusCh()">Inactivo</span>
          <span class="bg-color-success color-white f12 pt1 pb1 pl3 pr3 r5 ml3" v-else-if="pageData.status == 1" @click="statusCh()">Activo</span>
        </div>
        <div class="col-12 t-c pt5 fw f18 uppercase el1">
          <i class="iconfont icon-NATwangguan color-primary" v-if="pageData.nat_service == 1" @click="go_nat_service()"></i>
          <i class="iconfont icon-NATwangguan color-muted" v-else @click="go_nat_service()"></i>
          <i class="iconfont icon-cloud-link-full color-success" @click="go_cloud()" v-if="pageData.cloud_plan > 0"></i>
          <i class="iconfont icon-cloud-link-full color-muted" @click="go_cloud()" v-else></i> {{ pageData.enterprise_name }}
        </div>
        <div class="col-12 lh18 mt5 t-c f12">
          <div class="col-12">{{ pageData.address_1 }}</div>
          <div class="col-12">{{ pageData.address_2 }}</div>
          <div class="col-12">{{ pageData.address_3 }}</div>
          <div class="col-12">{{ pageData.address_4 }}</div>
        </div>
      </div>
    </div>
    <div class="h27"></div>
    <div class="col-12 pl20 pr20 pt8 f14 t-c pt20">
      <i class="iconfont icon-type-of-work-managem f20 color-primary"></i> Técnico: <span v-if="pageData.tec_name">{{pageData.tec_name}}</span> <span v-else>Nadie</span>
    </div>
    <div class="col-12 bg-color-white mt5 bb1">
      <div class="col-3 t-c lh40 f13" :class="ext_status === 'all' ? 'color-primary fw bb3-primary' : 'color-muted'" @click="extStatusCh('all')">Todas</div>
      <div class="col-3 t-c lh40 f13" :class="ext_status === 1 ? 'color-primary fw bb3-primary' : 'color-muted'" @click="extStatusCh(1)">Activo</div>
      <div class="col-3 t-c lh40 f13" :class="ext_status === 0 ? 'color-primary fw bb3-primary' : 'color-muted'" @click="extStatusCh(0)">Inactivo</div>
      <div class="col-3 t-c lh40 f13" :class="ext_status === -1 ? 'color-primary fw bb3-primary' : 'color-muted'" @click="extStatusCh(-1)">Bloqueado</div>
    </div>
    <div class="col-12 t-c bg-color1">
      <div class="col-12 color-black pl5 pr5 mt8 t-c" v-for="(extension, extension_i) in filtered_extension_list" v-bind:key="extension_i" @click="go_ext(extension.extid)">
        <div class="col-12 bg-color-white p5 r5">
          <div class="col-2 lh50 br1">
            <i class="iconfont icon-lock f30 color-muted" v-if="extension.status == -1"></i>
            <i class="iconfont icon-error f30 color-danger" v-else-if="extension.status == 0"></i>
            <i class="iconfont icon-diannao f30 color-primary" v-else></i>
          </div>
          <div class="col-9 pl10 f16 t-l pt10">
              <div class="col-12 uppercase mb5">[{{ extension.extension_code }}] <span class="fw">{{extension.extension_name}}</span>  - <span class="color-success f14">[ {{ extension.pos_ver }} ]</span> </div>
              <div class="col-12 f14 color-black">Vencimiento: <span  class="fw" :class="[extension.exp_day <= 0?'color-danger':'color-success']">{{extension.exp_day}}</span> días</div>
              <div class="col-12 f12 color-muted">Sincronización: {{extension.update_time}}</div>
          </div>
          <div class="col-1 color-muted t-r lh50"><i class="iconfont icon-31fanhui2"></i></div>
        </div>
      </div>
    </div>
    <div class="h5 col-12"></div>
    <div ref="app_foot" class="col-12 fixed-b color-white f14 bg-color1 lh50 h5 uppercase" v-if="pageData.tec_name == $store.state.account.user">
      <div class="col-6 bg-color-success t-c f12" @click="go_act(1)"><i class="iconfont icon-diannao color-white f22"></i> Agregar CAJA</div>
      <div class="col-6 bg-color-primary t-c f12" @click="go_act(2)"><i class="iconfont icon-jinrudianpu color-white f22"></i> agregar sucursal</div>
    </div>
    <div ref="app_foot" class="col-12 fixed-b color-white f14 bg-color1 lh50 h5 uppercase" v-else-if="pageData.tec_id == 0">
      <div class="col-12 bg-color-warning t-c f12" v-if="pageData.log_find == 1"><i class="iconfont icon-shalou color-white f22"></i> La solicitud se está procesando</div>
      <div class="col-12 bg-color-warning t-c f12" @click="get_it_confim()" v-else><i class="iconfont icon-31wode color-white f22"></i> Este es mi cliente</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Client',
  data () {
    return {
      appid: this.$route.query.appid,
      pageData: {},
      extension_list: [],
      ext_status: 1
    }
  },
  computed: {
    filtered_extension_list() {
      if(this.ext_status === 'all'){
        return this.extension_list;
      }
      return this.extension_list.filter((item) => {
        if(this.ext_status === 1){
          return Number(item.status) > 0;
        }
        return Number(item.status) === this.ext_status;
      });
    }
  },
  created: function () {
    this.get_pageData();
  },
  methods: {
    go_clients(){
      this.$router.push({name:'T_ClientsList'});
    },
    extStatusCh(status){
      if(this.ext_status === status){
        return;
      }
      this.ext_status = status;
    },
    get_pageData() {
      var post_data = {}
      post_data.appid = this.appid
      this.post(this.api_url + 'Tec/client',post_data,true).then((res)=>{
        if(res.status == 1){
          this.pageData = res.data;
          this.get_extension();
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    },
    get_extension(){
      var post_data = {}
      post_data.appid = this.appid
      this.post(this.api_url + 'Tec/extensions',post_data,true).then((res)=>{
        if(res.status == 1){
          this.extension_list = res.data;
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    },
    statusCh(){
      if(this.$store.state.account.user != this.pageData.tec_name && this.$store.state.account.account_grade != 99){
        this.$store.commit('setAlert',{type:'error',msg: "No tienes permiso"});
        return;
      }
      if(this.pageData.status == 1){
        this.$store.commit('setConfimBox',{type:'confim_exit',msg:'¿Está seguro de que desea desactivar este cliente?',_this:this,focus:'',method:'statusChPost',arg1:0});
      }else if(this.pageData.status == 0){
        this.statusChPost(1);
      }else if(this.pageData.status == -1){
        this.$store.commit('setConfimBox',{type:'confim_exit',msg:'¿Está seguro de que desea activar este cliente?',_this:this,focus:'',method:'statusChPost',arg1:1});
      }
    },
    statusChPost(status){
      var post_data = {}
      post_data.appid = this.appid
      post_data.status = status
      this.post(this.api_url + 'Tec/client_status_update',post_data,true).then((res)=>{
        if(res.status == 1){
          this.pageData.status = status;
          this.$store.commit('setAlert',{type:'success',msg: "Éxito"});
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    },
    //进入安装码
    go_install(){
      this.$router.push({name:'InstallCode'});
    },
    //进入激活
    go_act(act_type){
      this.$router.push({name:'Activation',params:{rif: this.pageData.license_type + this.pageData.license, act_type: act_type, store:this.pageData.store}});
    },
    //进入销售端
    go_ext(extid){
      this.$router.push({name:'T_Extension',query:{extid: extid}});
    },
    //进入云端
    go_cloud(){
      if(this.$store.state.account.user != this.pageData.tec_name && this.$store.state.account.account_grade != 99){
        this.$store.commit('setAlert',{type:'error',msg: "No tienes permiso"});
        return;
      }
      this.$router.push({name:'T_Cloud',query:{appid: this.appid}});
    },
    //进入NAT服务
    go_nat_service(){
      if(this.$store.state.account.user != this.pageData.tec_name && this.$store.state.account.account_grade != 99){
        this.$store.commit('setAlert',{type:'error',msg: "No tienes permiso"});
        return;
      }
      this.$router.push({name:'T_NATService',query:{appid: this.appid}});
    },
    get_it_confim(){
      this.$store.commit('setConfimBox',{type:'confim_exit',msg:'Revisaremos su solicitud y le notificaremos más tarde.',_this:this,focus:'',method:'get_it',arg1:''});
    },
    get_it(){
      var post_data = {}
      post_data.appid = this.appid;
      this.post(this.api_url + 'Tec/pos_ch_tec',post_data,true).then((res)=>{
        if(res.status == 1){
          this.$store.commit('setAlert',{type:'success',msg: "Éxito"});
          this.get_pageData();
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    },
    go_lic(){
      var post_data = {};
      post_data.rif = this.pageData.license_type + this.pageData.license;
      post_data.store = this.pageData.store;
      this.post(this.api_url + 'Tec/lic_make',post_data,true).then((res)=>{
        if(res.status == 1){
          this.$store.commit('setAlert',{type:'success',msg: "Éxito"});
          this.$router.back(-1);
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    }
  },
  mounted() {
    
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Technician/Client.vue